module.exports = __webpack_public_path__ + "img/partner_02.5c5fa2d1.png";